<h2 mat-dialog-title>
  Select A Declined Reason</h2>
<mat-dialog-content fxLayout="column">
  <mat-radio-group [(ngModel)]="selectedDeclinedReason" fxLayout="column">
    <mat-radio-button style="margin:12px;color:#5A5A5A" *ngFor="let declinedReason of data.declinedReasons | orderBy: 'reason'"
      [value]="declinedReason" fxLayout="row" fxLayoutAlign="space-between center">
      <span>{{declinedReason.reason}}</span>
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end end" style="margin-right:-8px;padding-bottom:8px;">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="primary" (click)="onConfirm(selectedDeclinedReason)" [disabled]="!selectedDeclinedReason">Select</button>
</div>